import { render, staticRenderFns } from "./ServiceTab.vue?vue&type=template&id=1669bc52&scoped=true&"
import script from "./ServiceTab.vue?vue&type=script&lang=js&"
export * from "./ServiceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1669bc52",
  null
  
)

export default component.exports